import { DialogContent as MuiDialogContent } from '@material-ui/core';
import cx from 'classnames';
import { forwardRef, ForwardRefRenderFunction } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './OverlayBody.styles';

export interface OverlayBodyProps extends WithStyles<typeof styles> {
  noPadding?: boolean;
}
/**
 * @deprecated Use OverlayBodyProps instead
 */
export type ModalBodyProps = OverlayBodyProps;

const OverlayBodyComponent: ForwardRefRenderFunction<HTMLDivElement, OverlayBodyProps> = (
  { classes, children, noPadding = false },
  ref
) => {
  return (
    <MuiDialogContent ref={ref} classes={{ root: cx(classes.root, { [classes.rootNoPadding]: noPadding }) }}>
      {children}
    </MuiDialogContent>
  );
};

export const OverlayBody = withStyles(styles)(forwardRef(OverlayBodyComponent));
/**
 * @deprecated Use OverlayBody instead
 */
export const ModalBody = OverlayBody;
